module.exports = __webpack_public_path__ + "media/images/flags/4x3/tkm-dfbaa21e5c2e3f51c147c5c277f66552.svg";